import React from 'react';
import Markdown from 'marked-react';
import { string } from 'prop-types';

const SAFE_URL_PATTERN = /^(https?:|\/)/i;

const renderer = {
  html: () => null,
  link: (href, text) => (SAFE_URL_PATTERN.test(href)
    ? <a href={href} target="_blank" rel="noopener noreferrer">{text}</a>
    : <span>{text}</span>),
  image: (href, text) => (SAFE_URL_PATTERN.test(href)
    ? (
      <a href={href} target="_blank" rel="noopener noreferrer">
        <img src={href} alt={text || ''} className="ticket-comment__image" />
      </a>
    )
    : null),
};

const MarkdownPreview = ({ content = '' }) => (
  <div className="ticket-comment__content">
    <Markdown gfm renderer={renderer}>{content}</Markdown>
  </div>
);

MarkdownPreview.propTypes = {
  content: string,
};

export default MarkdownPreview;
